module.exports = __webpack_public_path__ + "img/23.27fcad4b.jpg";